import { render } from "./ConectarInstancia.vue?vue&type=template&id=bfe65138&scoped=true"
import script from "./ConectarInstancia.vue?vue&type=script&lang=js"
export * from "./ConectarInstancia.vue?vue&type=script&lang=js"

import "./ConectarInstancia.vue?vue&type=style&index=0&id=bfe65138&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe65138"]])

export default __exports__